/* Nomi Chérie handwriting: renders [data-hand] notes as SVG glyph paths and "writes" them on.
   Usage: <span class="hand" data-hand="Bags|for real days" data-heart="end">Bags for real days</span>
   "|" = line break. data-heart = doodle position: end | below | none. data-doodle = heart | star | smiley | crown | sparkle | auto. data-indent = per-line indent in em (default .55). */
(function () {
  var A = window.NOMI_HAND;
  if (!A) return;
  var NS = 'http://www.w3.org/2000/svg';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // imperfect, hand-drawn doodles (100 x 110 box), drawn last. data-doodle picks one; "auto" varies by page and note
  var DOODLES = {
    heart: 'M50 28 C42 6 10 4 10 34 C10 62 40 82 52 106 C58 80 92 60 90 30 C88 6 58 6 48 34',
    star: 'M50 8 C54 22 58 32 63 43 C76 43 86 44 96 47 C85 54 77 60 69 66 C73 78 76 88 79 101 C68 93 59 86 50 79 C40 87 31 94 20 102 C24 89 28 78 32 66 C23 60 14 54 5 46 C17 44 28 43 38 43 C42 31 46 20 52 6',
    smiley: 'M54 10 C26 6 8 30 10 58 C12 88 36 105 58 101 C84 97 97 72 92 47 C88 22 70 7 44 13 M36 40 C35 45 36 49 37 54 M64 38 C64 43 65 47 66 52 M29 66 C38 86 63 88 73 63',
    crown: 'M13 92 C11 74 9 56 6 38 C15 47 23 55 31 63 C38 49 44 36 50 20 C56 35 62 48 69 61 C78 53 86 45 95 36 C92 55 90 73 88 93 C62 89 38 90 11 94 M6 27 l.1 0 M50 9 l.1 0 M96 25 l.1 0',
    sparkle: 'M50 6 C52 38 60 49 94 54 C60 59 53 71 50 104 C46 71 40 60 6 54 C40 49 47 38 49 8 M84 12 C85 20 87 23 95 24 C87 26 85 28 84 36 C83 28 81 26 74 24 C81 23 83 20 84 12'
  };
  var AUTO = ['heart', 'star', 'smiley', 'crown', 'sparkle'];
  function pick(kind, text) {
    if (DOODLES[kind]) return DOODLES[kind];
    var s = location.pathname + '|' + text, h = 0; // auto: stable per page + note, so each product page gets its own
    for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
    return DOODLES[AUTO[h % AUTO.length]];
  }
  var LINE_H = 900;
  var fits = [], fitTimer;
  window.addEventListener('resize', function () {
    clearTimeout(fitTimer);
    fitTimer = setTimeout(function () { fits.forEach(function (f) { f(); }); }, 120);
  });

  function build(el) {
    var text = el.getAttribute('data-hand');
    var heart = el.getAttribute('data-heart') || 'none';
    var indent = parseFloat(el.getAttribute('data-indent') || '0.55') * 1000;
    var lines = text.split('|');
    var svg = document.createElementNS(NS, 'svg');
    var glyphs = [];
    var maxX = 0, lastX = 0, lastY = 0;

    lines.forEach(function (line, li) {
      var x = li * indent, y = li * LINE_H;
      for (var i = 0; i < line.length; i++) {
        var g = A.g[line[i]];
        if (!g) continue;
        if (g.d) {
          var p = document.createElementNS(NS, 'path');
          p.setAttribute('d', g.d);
          p.setAttribute('transform', 'translate(' + x + ',' + y + ')');
          p.setAttribute('class', 'nm-hand-glyph');
          svg.appendChild(p);
          glyphs.push({ node: p, pause: 0 });
        } else if (glyphs.length) {
          glyphs[glyphs.length - 1].pause += 0.06; // space = tiny lift of the pen
        }
        x += g.a;
      }
      if (glyphs.length) glyphs[glyphs.length - 1].pause += 0.12; // new line
      maxX = Math.max(maxX, x); lastX = x; lastY = y;
    });

    var hNode = null, bottom = lastY + 330;
    if (heart !== 'none') {
      var kind = el.getAttribute('data-doodle') || 'heart';
      var HEART_SCALE = kind === 'heart' ? 3.6 : 5; // the detailed doodles need a little more room to read
      var hw = 100 * HEART_SCALE, hh = 110 * HEART_SCALE, hx, hy;
      if (heart === 'below') { hx = lastX * 0.55; hy = lastY + 220; bottom = hy + hh + 40; }
      else { hx = lastX + 90; hy = lastY - hh + 60; maxX = Math.max(maxX, hx + hw); }
      hNode = document.createElementNS(NS, 'path');
      hNode.setAttribute('d', pick(kind, text));
      hNode.setAttribute('transform', 'translate(' + hx + ',' + hy + ') scale(' + HEART_SCALE + ')');
      hNode.setAttribute('class', 'nm-hand-heart');
      svg.appendChild(hNode);
    }

    var pad = 90, top = -A.asc - 20;
    var vbW = maxX + pad * 2, vbH = bottom - top;
    svg.setAttribute('viewBox', (-pad) + ' ' + top + ' ' + vbW + ' ' + vbH);
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('preserveAspectRatio', 'xMinYMin meet');
    // Size in exact pixels (font-size sets the scale, the nearest real container caps it). Explicit width and
    // height attributes behave the same in every browser, unlike em widths with percentage max-widths.
    function fit() {
      var fs = parseFloat(getComputedStyle(el).fontSize) || 40;
      var want = vbW / 1000 * fs, host = el.parentElement;
      while (host && host.clientWidth < 60) host = host.parentElement;
      var avail = host ? host.clientWidth * 0.96 : want;
      var w = Math.max(40, Math.min(want, avail));
      svg.setAttribute('width', w.toFixed(1));
      svg.setAttribute('height', (w * vbH / vbW).toFixed(1));
    }
    fit();
    fits.push(fit);

    var sr = document.createElement('span');
    sr.className = 'sr-only';
    sr.textContent = el.textContent || text.replace(/\|/g, ' ');
    el.textContent = '';
    el.appendChild(sr);
    el.appendChild(svg);
    el.classList.add('nm-hand--ready');

    var api = { played: false };
    function prep() {
      glyphs.forEach(function (g) {
        var len = g.node.getTotalLength();
        g.len = len;
        g.node.style.transition = 'none';
        g.node.style.strokeDasharray = len;
        g.node.style.strokeDashoffset = len;
        g.node.style.fillOpacity = 0;
      });
      if (hNode) {
        var hl = hNode.getTotalLength();
        hNode.style.transition = 'none';
        hNode.style.strokeDasharray = hl;
        hNode.style.strokeDashoffset = hl;
      }
      api.played = false;
    }
    api.reset = function () { if (!REDUCED) prep(); };
    api.play = function () {
      if (REDUCED || api.played) return;
      api.played = true;
      svg.getBoundingClientRect(); // flush
      var speed = parseFloat(el.getAttribute('data-speed') || '1');
      var t = parseFloat(el.getAttribute('data-delay') || '0');
      glyphs.forEach(function (g) {
        var d = Math.min(0.34, Math.max(0.08, g.len / 13000)) / speed;
        g.node.style.transition = 'stroke-dashoffset ' + d + 's linear ' + t + 's, fill-opacity .3s ease ' + (t + d * 0.55) + 's';
        g.node.style.strokeDashoffset = 0;
        g.node.style.fillOpacity = 1;
        t += d * 0.45 + g.pause / speed;
      });
      if (hNode) {
        hNode.style.transition = 'stroke-dashoffset .75s cubic-bezier(.6,.05,.3,1) ' + (t + 0.12) + 's';
        hNode.style.strokeDashoffset = 0;
      }
    };
    if (!REDUCED) prep();
    el.nomiHand = api;
    return api;
  }

  function init(root) {
    var els = [].slice.call((root && root.querySelectorAll ? root : document).querySelectorAll('[data-hand]:not(.nm-hand--ready)'));
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.nomiHand.play(); io.unobserve(e.target); }
      });
    }, { threshold: 0.55 }) : null;
    els.forEach(function (el) {
      build(el);
      if (el.hasAttribute('data-hand-manual')) return; // played by a section script
      if (io) io.observe(el); else el.nomiHand.play();
    });
    document.dispatchEvent(new CustomEvent('nomi:hand-ready'));
  }
  window.NomiHand = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
